import React from 'react';
import LogoInverted from '../icons/LogoInverted';
import Link from '../components/Link/Link';
// import Cookies from '../pages/Cookies';
// import Privacy from '../pages/Privacy';
// import Terms from '../pages/Terms';

interface Props {
  handleClickOpenDialog: (title: string, content?: JSX.Element) => void;
  handleMenuClick: (sectionDest: string) => void;
}

const Footer: React.FC<Props> = ({ handleClickOpenDialog, handleMenuClick }) => {
  return (
    <footer className="w-full flex flex-col items-center">
      <div className="footer-content-wrapper flex flex-col">
        <div className="logo" onClick={() => handleMenuClick('intro')}>
          <LogoInverted />
        </div>

        <nav className="footer-menu">
          <ul className="flex justify-between">
            {/* <li>
              <Link title="Terms & Conditions" content={<Terms />} onClickHandler={handleClickOpenDialog} />
            </li>
            <li>
              <Link title="Cookies Policy" content={<Cookies />} onClickHandler={handleClickOpenDialog} />
            </li>
            <li>
              <Link title="Privacy Policy" content={<Privacy />} onClickHandler={handleClickOpenDialog} />
            </li> */}
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
